import { useSellerOnboardingVariant } from '../../../hooks/use-seller-setting';
import { EnabledOnboardingVariantTypes, SHIPPING_VOLUME, FEATURE_INTEREST, COMPANY_PHONE } from '../constants';
import { useSetupContext } from '../context';

const defaultPageOrder = [SHIPPING_VOLUME, FEATURE_INTEREST];
const ssoPageOrder = [COMPANY_PHONE, SHIPPING_VOLUME, FEATURE_INTEREST];

const variantPageMap = {
  [EnabledOnboardingVariantTypes.ONE]: defaultPageOrder,
  [EnabledOnboardingVariantTypes.SHOW_PROGRESSIVE_DISCLOSURE]: defaultPageOrder,
  [EnabledOnboardingVariantTypes.TWO]: ssoPageOrder,
  [EnabledOnboardingVariantTypes.SHOW_SSO_PROGRESSIVE_DISCLOSURE]: ssoPageOrder,
};

export const useVariantPages = () => {
  const sellerSettingVariant = useSellerOnboardingVariant();
  const variantPages = variantPageMap[sellerSettingVariant];
  return variantPages;
};

export const useFindCurrentStepIndex = () => {
  const { currentSetupStep } = useSetupContext();
  const pages = useVariantPages();
  return pages.findIndex((page) => page === currentSetupStep);
};
